.cq{border:1px solid #ddd;}